import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'sim-progress-bar',
    imports: [NgIf],
    templateUrl: './sim-progress-bar.component.html',
    styleUrls: ['./sim-progress-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimProgressBarComponent {
  private _barValue = 0;
  private _barValueToAdd = 0;
  private _barMaxValue = 1;
  private _barHeight = 10;
  private _showDangerRange = true;
  readonly dangerRange = 80;

  @Input() set barHeight(value: number) {
    this._barHeight = value;
  }

  get barHeight(): number {
    return this._barHeight;
  }

  @Input() set hideDangerRange(value: BooleanInput) {
    this._showDangerRange = !coerceBooleanProperty(value);
  }

  get showDangerRange(): boolean {
    return this._showDangerRange;
  }

  @Input() set barValue(value: number) {
    this._barValue = value;
  }

  get barValue(): number {
    return this._barValue;
  }

  @Input() set barValueToAdd(value: number) {
    this._barValueToAdd = value + this._barValue;
  }

  get barValueToAdd(): number {
    return this._barValueToAdd;
  }

  @Input() set barMaxValue(value: number) {
    this._barMaxValue = value;
  }

  get barMaxValue(): number {
    return this._barMaxValue;
  }
}
